declare const window: any;

/**
 * Attempts to close/exit a Capacitor app using various fallback methods
 * This is useful when you need to programmatically close the app, such as after
 * opening external URLs like App Store links
 */
export function attemptCloseCapacitorApp(): void {
    // For Capacitor iOS, we need to terminate the app
    // Try different methods to close the app
    if ((window as any).webkit && (window as any).webkit.messageHandlers && (window as any).webkit.messageHandlers.bridge) {
        // iOS WebView bridge method
        (window as any).webkit.messageHandlers.bridge.postMessage({ action: 'exitApp' });
    } else if ((navigator as any).app && (navigator as any).app.exitApp) {
        // Cordova-style exit
        (navigator as any).app.exitApp();
    } else {
        // Force close the app by navigating to a special URL that triggers app termination
        // This is a common pattern in iOS Capacitor apps
        window.location.href = 'capacitor://close';
    }
}
